import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMicroGenres } from 'services/store/ai/selectors';
import { MicroGenreSelectorContainer as MicroGenreSelector } from '../MicroGenreSelector';
import PrimaryGenreSelector from './PrimaryGenreSelector';

type PropsType = {
  genre: string;
  onPrimaryGenreChange: (primaryGenre: string) => void;
  onMicroGenreChange: (microGenre: string) => void;
};

const PrimaryGenreSelectorContainer = ({
  genre,
  onPrimaryGenreChange,
  onMicroGenreChange,
}: PropsType) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const microGenres = useSelector(selectMicroGenres(genre));
  const hasMicroGenres = microGenres.length > 0;

  return (
    <Stack
      sx={{
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.grey[800],
      }}
    >
      <Stack gap={theme.spacing(1)} padding={theme.spacing(2)}>
        <Typography fontSize={16} fontWeight={700}>
          {t('aiMusicGenerator:lockedField:genre')}
        </Typography>
        <PrimaryGenreSelector value={genre} onChange={onPrimaryGenreChange} />
      </Stack>

      {hasMicroGenres && (
        <>
          <Divider />
          <Stack gap={theme.spacing(1)} padding={theme.spacing(2)}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography fontSize={14} fontWeight={700}>
                {t('aiMusicGenerator:lockedField:microGenre')}
              </Typography>
              <Typography
                fontSize={14}
                fontWeight={400}
                color={theme.palette.grey[500]}
              >
                {t('aiMusicGenerator:optional')}
              </Typography>
            </Box>
            <MicroGenreSelector value={genre} onChange={onMicroGenreChange} />
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default PrimaryGenreSelectorContainer;
